/**
 * API Configuration
 * Gère les URLs pour dev et production
 */
export const API_CONFIG = {
  baseURL: import.meta.env.VITE_API_URL || 'https://acquiz-app-back-end-506667351823.us-central1.run.app/api/v1',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
};

export const WS_CONFIG = {
  url: import.meta.env.VITE_WS_URL || 'https://acquiz-app-back-end-506667351823.us-central1.run.app',
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionAttempts: 5,
};